<template>
  <ul class="group_self_feedpost-action" v-if="!isSelf">
    <div class="group_self_feedpost-user">
      <a href="javascript:;">
        <img class="user-logo mr-2" :src="item.userLogoSmail"
      /></a>
      <span class="group_self_feedpost-username">
        <!-- <a href="javascript:;">{{ item.sgL_UsersName }} </a> -->
        <router-link :to="{name:'customerPublishLook',query: { 'authorId': item.sgL_UserID } }">
          {{ item.sgL_UsersName }}
        </router-link>
        </span
      >
      <span class="publish-time">{{ item.sgL_PG_CAddTimerI }}</span>
    </div>
    <div style="float: right">
      <a
        href="javascript:;"
        @click="
          $emit(
            'addfavorite',
            item.id,
            item.sgL_TypeI,
            5,
            null,
            1,
            'sgL_IsLike',
            item,
            'sgL_PG_CTotalLike'
          )
        "
        ><!-- like icon -->
        <li class="like">
          <i
            class="fa-thumbs-up mr-1"
            :class="{
              far: !item.sgL_IsLike,
              fas: item.sgL_IsLike,
            }"
            ><span v-if="item.sgL_PG_CTotalLike">{{
              item.sgL_PG_CTotalLike
            }}</span></i
          >
        </li>
      </a>
      <div class="group_like-user" v-if="item.sgL_IsLikeLst.length">
        <!-- like user icon -->
        <img
          v-for="(info, ix) in item.sgL_IsLikeLst.slice(0, 3)"
          :key="info.id"
          class="user-like"
          :src="info.userLogoSmail"
        />
        <div class="group_like-pop">
          <p v-for="(info, ix) in item.sgL_IsLikeLst" :key="info.id">
            {{ info.sgL_Mem_DisplayName }}
          </p>
        </div>
      </div>
      <a href="javascript:void(0);" @click="$emit('commentShow')"
        ><!-- comment icon -->
        <li class="comment">
          <i class="far fa-comment mr-1"></i>
        </li>
      </a>
      <div class="group_self_feedpost-more">
        <i class="fa fa-ellipsis-h"></i
        ><!-- function icon -->
        <div class="group_self_feedpost-menus">
          <a
            href="javascript:;"
            @click="
              $emit(
                'addfavorite',
                item.id,
                item.sgL_TypeI,
                5,
                null,
                0,
                'sgL_IsFavorite',
                item
              )
            "
          >
            <li class="bookmark">
              <i
                class="fa-bookmark mr-1"
                :class="{
                  far: !item.sgL_IsFavorite,
                  fas: item.sgL_IsFavorite,
                }"
              ></i>
               {{ $t('Social.group.detailCard.bookmark') }}
            </li>
          </a>
          <a href="javascript:;" @click="$emit('share')">
            <li class="share">
              <i class="fa fa-share mr-1"></i>
               {{ $t('Social.group.detailCard.share') }}
            </li>
          </a>
          <a href="javascript:;" @click="$emit('report')">
            <li class="report">
              <i class="far fa-flag mr-1"></i>
               {{ $t('Social.group.detailCard.flag') }}
            </li>
          </a>
          <a
            href="javascript:;"
            @click="$emit('edit')"
            v-if="isCanModify(item.sgL_UserID)"
          >
            <li class="mondify">
              <i class="fas fa-edit"></i>
               {{ $t('Social.group.detailCard.EditorialPost') }}
            </li>
          </a>
          <a
            href="javascript:;"
            v-if="isCanDel(item.sgL_UserID)"
            @click="$emit('deleteFun')"
          >
            <li class="delete">
              <i class="far fa-trash-alt mr-1"></i>
               {{ $t('Social.group.detailCard.DeletePost') }}
            </li>
          </a>
        </div>
      </div>
    </div>
  </ul>
  <ul v-else class="group_feedpost-action">
    <div class="group_feedpost-user">
      <!-- user name & image box -->
      <a href="javascript:;">
        <img class="user-logo mr-2" :src="item.userLogoSmail" alt="user-icon"
      /></a>
      <span class="group_feedpost-username">
        <!-- <a href="javascript:;">
          {{ item.sgL_UsersName }}
        </a> -->
        <router-link :to="{name:'customerPublishLook',query: { 'authorId': item.sgL_UserID } }">
          {{ item.sgL_UsersName }}
        </router-link>
        </span
      >
      <span class="publish-time">{{ item.sgL_PG_CAddTimerI }}</span>
    </div>
    <div>
      <!-- function icon -->
      <div class="group_feedpost-more">
        <i class="fa fa-ellipsis-h"></i>
        <div class="group_reply-menus">
          <a
            href="javascript:;"
            @click="
              $emit(
                'addfavorite',
                item.id,
                item.sgL_TypeI,
                5,
                null,
                0,
                'sgL_IsFavorite',
                item
              )
            "
          >
            <li class="bookmark">
              <i
                class="fa-bookmark mr-1"
                :class="{
                  far: !item.sgL_IsFavorite,
                  fas: item.sgL_IsFavorite,
                }"
              ></i>
               {{ $t('Social.group.detailCard.bookmark') }}
            </li>
          </a>
          <a href="javascript:;" @click="$emit('share')">
            <li class="share">
              <i class="fa fa-share mr-1"></i>
               {{ $t('Social.group.detailCard.share') }}
            </li>
          </a>
          <a href="javascript:;" @click="$emit('report')">
            <li class="report">
              <i class="far fa-flag mr-1"></i>
               {{ $t('Social.group.detailCard.flag') }}
            </li>
          </a>
          <a
            href="javascript:;"
            @click="$emit('edit')"
            v-if="isCanModify(item.sgL_UserID)"
          >
            <li class="mondify">
              <i class="fas fa-edit"></i>
               {{ $t('Social.group.detailCard.EditorialPost') }}
            </li>
          </a>
          <a
            href="javascript:;"
            v-if="isCanDel(item.sgL_UserID)"
            @click="$emit('deleteFun')"
          >
            <li class="delete">
              <i class="far fa-trash-alt mr-1"></i>
               {{ $t('Social.group.detailCard.DeletePost') }}
            </li>
          </a>
        </div>
      </div>
      <a
        href="javascript:;"
        @click="
          $emit(
            'addfavorite',
            item.id,
            item.sgL_TypeI,
            5,
            null,
            1,
            'sgL_IsLike',
            item,
            'sgL_PG_CTotalLike'
          )
        "
        ><!-- like icon -->
        <li class="like">
          <i
            class="fa-thumbs-up mr-1"
            :class="{
              far: !item.sgL_IsLike,
              fas: item.sgL_IsLike,
            }"
            ><span v-if="item.sgL_PG_CTotalLike">{{
              item.sgL_PG_CTotalLike
            }}</span></i
          >
        </li>
      </a>
      <div class="group_like-user" v-if="item.sgL_IsLikeLst.length">
        <!-- like user icon -->
        <img
          v-for="(info, ix) in item.sgL_IsLikeLst.slice(0, 3)"
          :key="info.id"
          class="user-like"
          :src="info.userLogoSmail"
        />
        <div class="group_like-pop">
          <p v-for="(info, ix) in item.sgL_IsLikeLst" :key="info.id">
            {{ info.sgL_Mem_DisplayName }}
          </p>
        </div>
      </div>
      <a href="javascript:void(0);" @click="$emit('commentShow')"
        ><!-- reply comment icon -->
        <li class="comment">
          <i class="far fa-comment mr-1"></i>
        </li>
      </a>
    </div>
  </ul>
</template>

<script>
export default {
  props: ["item", "sgL_UsersId"],
  data() {
    return {};
  },
  methods: {
    isCanDel(id) {
      if (
        this.loginUser.userId === this.sgL_UsersId ||
        id === this.loginUser.userId
      ) {
        return true;
      }
      return false;
    },
    isCanModify(id) {
      if (id === this.loginUser.userId) {
        return true;
      }
      return false;
    },
  },
  computed: {
    isSelf() {
      return this.item.sgL_UserID === this.loginUser.userId;
    },
  },
};
</script>

<style scoped>
.group_self_feedpost-action {
  height: 40px;
}
.group_self_feedpost-action li {
  display: inline-block;
  padding: 8px;
  text-align: center;
}

.group_self_feedpost-action li:hover {
  background: #f5f5f5;
  border-radius: 4px;
}
.publish-time {
  display: block;
  font-size: 0.575rem;
  color: #757575;
}
.group_feedpost-user {
  background-image: url("../../../assets/images/group_chat.png");
}
.group_self_feedpost-user {
  background-image: url("../../../assets/images/group_chat2.png");
}
.group_like-user .user-like {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  vertical-align: middle;
  width: 22px;
  /* width of container */
  height: 22px;
  /* height of container */
  object-fit: cover;
  margin-left: -15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/group/detailCard.vue